const testimonials = [
  {
    name: 'Sarah M.',
    location: 'Nazareth, PA',
    rating: 5,
    text: 'Absolutely the best birthday party experience! Kelsey was amazing with the kids and every single one of them left so proud of their painting. We will 100% be back.',
    type: 'Birthday Party',
    accentColor: '#ff4322',
  },
  {
    name: 'Jessica L.',
    location: 'Bethlehem, PA',
    rating: 5,
    text: 'I came in thinking I had zero artistic talent and left with something I actually want to hang on my wall. The vibe is so relaxed and fun. Cannot recommend enough!',
    type: 'Art Class',
    accentColor: '#ffb300',
  },
  {
    name: 'Tara & Group',
    location: 'Easton, PA',
    rating: 5,
    text: 'We booked a private bachelorette and it was the highlight of the whole weekend. Kelsey made it personal, creative, and so much fun. Truly memorable.',
    type: 'Private Party',
    accentColor: '#e0285a',
  },
  {
    name: 'Mike R.',
    location: 'Allentown, PA',
    rating: 5,
    text: 'Brought my daughter for her first art class and she had the time of her life. The studio is so welcoming. We\'re already booked for next month.',
    type: 'Kids Class',
    accentColor: '#ff7120',
  },
  {
    name: 'Amanda D.',
    location: 'Northampton, PA',
    rating: 5,
    text: 'Bought a gift card for my mom and she called me saying it was one of the best gifts she\'d ever received. Seamless experience from booking to final painting.',
    type: 'Gift Card',
    accentColor: '#ff4322',
  },
  {
    name: 'Lauren K.',
    location: 'Nazareth, PA',
    rating: 5,
    text: 'I\'ve been to several of the open classes and each one is just as fun as the last. Kelsey always makes you feel like a real artist. This place is a gem in Nazareth.',
    type: 'Art Class',
    accentColor: '#ffb300',
  },
];

const Testimonials = () => {
  return (
    <section className="py-20 md:py-28 relative overflow-hidden" style={{ background: '#080808' }}>
      {/* Decorative splash */}
      <div className="absolute top-0 left-0 w-80 h-80 pointer-events-none" style={{ background: 'radial-gradient(ellipse, rgba(255,67,34,0.06) 0%, transparent 70%)', borderRadius: '60% 40% 70% 30% / 50% 60% 40% 50%' }} />
      <div className="absolute bottom-0 right-0 w-64 h-64 pointer-events-none" style={{ background: 'radial-gradient(ellipse, rgba(255,179,0,0.05) 0%, transparent 70%)' }} />

      <div className="max-w-7xl mx-auto px-4 md:px-8 relative z-10">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
          <div>
            <div className="flex items-center gap-3 mb-5">
              <div className="h-px w-8 bg-artden-coral" />
              <span className="section-label">Client Experiences</span>
            </div>
            <h2 className="font-cormorant font-medium text-white leading-[1.0] tracking-tight" style={{ fontSize: 'clamp(2.5rem, 5vw, 4.5rem)' }}>
              What Our<br />
              <em className="font-light italic" style={{ color: '#ffb300' }}>Guests Are Saying</em>
            </h2>
          </div>
          <div className="flex items-center gap-2">
            {[1,2,3,4,5].map(s => (
              <span key={s} className="w-5 h-5 flex items-center justify-center">
                <i className="ri-star-fill text-artden-amber text-lg"></i>
              </span>
            ))}
            <span className="ml-2 font-outfit text-artden-muted text-sm">5.0 · 100+ happy guests</span>
          </div>
        </div>

        {/* Review cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="relative rounded-2xl p-6 border border-white/6 hover:border-white/12 transition-all duration-300 flex flex-col"
              style={{ background: '#111111' }}
            >
              {/* Accent dot */}
              <div className="absolute top-5 right-5 w-2 h-2 rounded-full" style={{ background: t.accentColor }} />

              {/* Type badge */}
              <span
                className="inline-block text-xs font-semibold font-outfit px-3 py-1 rounded-full mb-4 self-start"
                style={{ background: `${t.accentColor}18`, color: t.accentColor }}
              >
                {t.type}
              </span>

              {/* Stars */}
              <div className="flex gap-0.5 mb-4">
                {[1,2,3,4,5].map(s => (
                  <span key={s} className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-artden-amber text-sm"></i>
                  </span>
                ))}
              </div>

              <p className="font-outfit text-white/60 text-sm leading-relaxed flex-1 mb-5">
                "{t.text}"
              </p>

              <div className="flex items-center gap-3 pt-4 border-t border-white/6">
                <div
                  className="w-8 h-8 flex items-center justify-center rounded-full shrink-0"
                  style={{ background: `${t.accentColor}20` }}
                >
                  <i className="ri-user-line text-xs" style={{ color: t.accentColor }}></i>
                </div>
                <div>
                  <p className="font-outfit text-white text-sm font-semibold">{t.name}</p>
                  <p className="font-outfit text-artden-muted text-xs">{t.location}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-12 text-center">
          <a
            href="https://artdenstudio.com/calendar/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2.5 bg-artden-coral hover:brightness-110 text-white font-semibold px-8 py-4 rounded-full transition-all whitespace-nowrap"
          >
            Join Our Happy Guests — Book a Class
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
